import {RecentUserSignup} from '../models/Analytics';
import {PaginatedApiReponse} from '../models/ApiResponse';
import {OrgLastAccessedModel} from '../models/Oganization/OrgLastAccessedModel';
import type {StudioCostQuery} from '../models/StudioCosts';
import {apiClient} from './baseApiClient';

/** What the platform client resolves a SuperAdmin Studio request to; a failure has a status. */
export interface StudioAdminResponse {
  success: boolean;
  /** A failure's HTTP status; 0 when the request never reached the server. */
  status?: number;
  data?: unknown;
  errors?: unknown[];
}

class AnalyticsApi {
  public async getAdminAnalytics() {
    return apiClient.get(`/admin/statistic`);
  }

  public async getLastAccessData(
    page: number,
    pageSize: number,
  ): Promise<PaginatedApiReponse<OrgLastAccessedModel>> {
    return apiClient.post(`admin/organizations/last_access`, {page, pageSize});
  }

  public async getRecentSignups(
    page: number,
    pageSize: number,
  ): Promise<PaginatedApiReponse<RecentUserSignup>> {
    return apiClient.post(`admin/users`, {page, pageSize});
  }

  /**
   * Studio's provider and compute costs for a period (SuperAdmin only). The response is read
   * through normalizeStudioCostReport; filters left out are not sent.
   */
  public async getStudioCosts(query: StudioCostQuery = {}) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query))
      if (value !== undefined && value !== null && value !== '')
        params.append(key, String(value));
    const search = params.toString();
    return apiClient.get<unknown, StudioAdminResponse>(
      `/studio-admin/costs${search ? `?${search}` : ''}`,
    );
  }

  /** One job's cost receipts, compute rows and numbered renders (SuperAdmin only). */
  public async getStudioJobCosts(jobId: string) {
    return apiClient.get<unknown, StudioAdminResponse>(
      `/studio-admin/jobs/${encodeURIComponent(jobId)}/costs`,
    );
  }
}

export default AnalyticsApi;
